'use client'

import Image from 'next/image'
import LocalizedClientLink from '@modules/common/components/localized-client-link'
import { HttpTypes } from '@medusajs/types'

interface CategoryWithImage extends HttpTypes.StoreProductCategory {
  image_url?: string
}

interface ModernCategoriesProps {
  categories: CategoryWithImage[]
}

export function ModernCategories({ categories }: ModernCategoriesProps) {
  if (!categories || categories.length === 0) return null

  // Show up to 6 categories in a responsive grid
  const display = categories.slice(0, 6)

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900 mb-2">
            Shop by Category
          </h2>
          <p className="text-gray-500 text-sm tracking-wide">Find exactly what you&apos;re looking for</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {display.map((cat, i) => (
            <LocalizedClientLink
              key={cat.id || i}
              href={`/categories/${cat.handle}`}
              className="group relative overflow-hidden rounded-xl aspect-[4/5] bg-gray-100"
            >
              {cat.image_url && (
                <Image
                  src={cat.image_url}
                  alt={cat.name}
                  fill
                  className="object-cover transition-transform duration-700 group-hover:scale-105"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                <h3 className="text-white font-semibold text-sm md:text-lg uppercase tracking-wider">
                  {cat.name}
                </h3>
                <span className="text-white/70 text-xs mt-1 inline-block group-hover:text-white transition-colors">
                  Shop now →
                </span>
              </div>
            </LocalizedClientLink>
          ))}
        </div>
      </div>
    </section>
  )
}
